module.exports = __webpack_public_path__ + "static/a4-cbc7f0ae6f45f0b98b03be7e1ac6e87f.png";